import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PaymentFormResponse } from "../model/PaymentFormResponse";
import { FileResponseModel } from "../model/FileResponseModel";
import { PaymentSettlementResponse } from "../model/PaymentSettlementResponse";
import { ViewPaymentDetailModel } from "../model/ViewPaymentDetailModel";
import { Page } from "../model/Page";
import { PaymentSettlementModel } from "../model/PaymentSettlementModel";
import { AppealDetailModel } from "../model/AppealDetailModel";

import { InstallmentAppealModel } from "../model/InstallmentAppealModel";
import { InstallmentExtendModel } from "../model/InstallmentTypeModel";
import { AppealHearingCallModel } from "../model/AppealHearingCallModel";
import { PaymentSettlementModelPageWrapper } from "../model/PaymentSettlementModelPageWrapper";
import { PaymentDashboardModel } from "../model/PaymentDashboardModel";
import { AppealHearingSaveModel } from "../model/AppealHearingSaveModel";
import { EligibilitySaveModel } from "../model/EligibilitySaveModel";
import { PaymentRefundModelPageWrapper } from "../model/PaymentRefundModelPageWrapper";
import { ViewPaymentRefundDetailModel } from "../model/ViewPaymentRefundDetailModel";
import { PaymentRefundSaveModel } from "../model/PaymentRefundSaveModel";
import { PaymentExtensionModel } from "../model/PaymentExtensionModel";

@Injectable({
  providedIn: "root",
})
export class PaymentSettlementService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  getLotteryName() {
    return this.httpClient.get<PaymentFormResponse>(ApiUrls.initLotteryName);
  }
  initBoardName() {
    return this.httpClient.get<PaymentFormResponse>(ApiUrls.initBoardName);
  }
  fetchDetailView(applicationNo: number) {
    return this.httpClient.get<ViewPaymentDetailModel>(
      ApiUrls.viewPaymentDetail.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }

  fetchPaymentDetailView(applicationNo: number) {
    return this.httpClient.get<ViewPaymentDetailModel>(
      ApiUrls.getPaymentDetailsList.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }

  getAccountOfficerConfirmedList(
    lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<PaymentSettlementModelPageWrapper>(
      ApiUrls.getAccountOfficerConfirmedList
        .replace(`{lotteryEventId}`, lotteryEventId)
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
  getApplicantHearingList(
    // lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AppealDetailModel>>(
      ApiUrls.getApplicantHearingList
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
  getChangeEligibilityList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AppealDetailModel>>(
      ApiUrls.getChangeEligibilityList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)
        reqParams
    );
  }
  getPaymentDefaulterList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AppealDetailModel>>(
      ApiUrls.getPaymentDefaulterList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)
        reqParams
    );
  }
  getChangeEligibilityFilterList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<PaymentSettlementResponse>>(
      ApiUrls.getChangeEligibilityFilterList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)

        reqParams
    );
  }
  getAppealButtonShowFilterList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<PaymentSettlementResponse>>(
      ApiUrls.getAppealButtonShowFilterList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)

        reqParams
    );
  }
  getRevertEligibilityFilterList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<PaymentSettlementResponse>>(
      ApiUrls.getRevertEligibilityFilterList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)

        reqParams
    );
  }
  getApplicantHearingFilterList(
    // lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<PaymentSettlementResponse>>(
      ApiUrls.getApplicantHearingFilterList
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
  getRevertChangeEligibilityList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<PaymentSettlementResponse>>(
      ApiUrls.getRevertChangeEligibilityList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)

        reqParams
    );
  }
  getAppealButtonShowList(
    // lotteryEventId: string,
    // statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AppealDetailModel>>(
      ApiUrls.getAppealButtonShowList +
        // .replace(`{lotteryEventId}`, lotteryEventId.toString())
        // .replace(`{statusId}`, statusId)
        reqParams
    );
  }
  getAccountOfficerFilterList(
    lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<PaymentSettlementModelPageWrapper>(
      ApiUrls.getAccountOfficerFilterList
        .replace(`{lotteryEventId}`, lotteryEventId)
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  fetchAsFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAsFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchForm16BFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchForm16BFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchQbFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchQbFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchChallanFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchChallanFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  statusFile(status: any, applicationNo: string) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${
        ApiUrls.saveTdsStatus.replace("{applicationNo}", applicationNo) +
        "?status=" +
        status
      }`,
      null
    );
  }

  accountOfficerApprove(status: any, applicationNo: string) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${
        ApiUrls.accountOfficerApprove.replace(
          "{applicationNo}",
          applicationNo
        ) +
        "?status=" +
        status
      }`,
      null
    );
  }

  saveEligibility(saveEligibility: EligibilitySaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveEligibility}`,
      saveEligibility
    );
  }
  savePaymentDefaulter(saveEligibility: EligibilitySaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.savePaymentDefaulter}`,
      saveEligibility
    );
  }
  saveAppealButton(saveEligibility: EligibilitySaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveAppealButton}`,
      saveEligibility
    );
  }
  saveRevertEligibility(saveEligibility: EligibilitySaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveRevertEligibility}`,
      saveEligibility
    );
  }
  fetchAppealDetailView(applicationNo: number, appealType: string) {
    return this.httpClient.get<AppealDetailModel>(
      ApiUrls.viewAppealDetail
        .replace("{applicationNo}", applicationNo.toString())
        .replace("{appealType}", appealType)
    );
  }
  fetchInstallmentType(applicationNo: number, appealType: string) {
    return this.httpClient.get<InstallmentExtendModel>(
      ApiUrls.fetchInstallmentType
        .replace("{applicationNo}", applicationNo.toString())
        .replace("{appealType}", appealType)
    );
  }
  viewInstallmentType(applicationNo: string) {
    return this.httpClient.get<InstallmentExtendModel>(
      ApiUrls.viewInstallmentType.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }
  rejectedStatusFile(remark: string, status: any, applicationNo: string) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${
        ApiUrls.saveRejectTdsStatus
          .replace("{remark}", remark)
          .replace("{applicationNo}", applicationNo) +
        "?status=" +
        status
      }`,
      null
    );
  }

  fetchAppealfile(appealfile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAppealfile
        .replace("{appealfile}", appealfile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchAppealDocFile(appealfile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAppealDocFile
        .replace("{appealfile}", appealfile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }
  fetchOrderfile(orderfile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchOrderDocFile
        .replace("{orderfile}", orderfile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  rejectedAppeal(rejectStatus: AppealHearingSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveRejectAppeal}`,
      rejectStatus
    );
  }
  saveAppealHearing(AppealHearingCall: AppealHearingCallModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.saveAppealHearing,

      AppealHearingCall
    );
  }
  saveApprovedDocument(approve: AppealHearingSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveApprovedDocument}`,
      approve
    );
  }
  saveAppealApprove(
    status: any,
    applicationNo: string,
    appealDate: any,
    remark: any
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${
        ApiUrls.saveAppealApprove
          .replace("{applicationNo}", applicationNo)

          .replace("{remark}", remark) +
        "?status=" +
        status
      }`,
      null
    );
  }

  // saveApprovedDocument(applicationNo: string, appealType: string) {
  //   return this.httpClient.post<{ errorMessage: string }>(
  //     `${ApiUrls.saveApprovedDocument
  //       .replace("{applicationNo}", applicationNo)
  //       .replace("{appealType}", appealType)}`,
  //     null
  //   );
  // }
  saveApprovedPayment(installmentAppealModel: InstallmentAppealModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveApprovedPayment}`,
      installmentAppealModel
    );
  }
  fetchpaymentDashboardDetails() {
    return this.httpClient.get<PaymentDashboardModel>(ApiUrls.paymentDashboard);
  }
  getPaymentRefundBeforePOLList(
    lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<PaymentRefundModelPageWrapper>(
      ApiUrls.getPaymentRefundBeforePOLList
        .replace(`{lotteryEventId}`, lotteryEventId)
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
  viewaymentRefundDetail(applicationNo: number, statusId: string) {
    return this.httpClient.get<ViewPaymentRefundDetailModel>(
      ApiUrls.viewaymentRefundDetail
        .replace(`{statusId}`, statusId)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }
  getPaymentRefundDetailsList(applicationNo: number) {
    return this.httpClient.get<ViewPaymentRefundDetailModel>(
      ApiUrls.getPaymentRefundDetailsList.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }
  accountRefundApproveByClerk(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.accountRefundApproveByClerk}`,
      payload
    );
  }
  accountRefundCloseByClerk(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.accountRefundCloseByClerk}`,
      payload
    );
  }
  accountRefundApproveByAccount(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.accountRefundApproveByAccount}`,
      payload
    );
  }
  accountRefundApproveByExpendature(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.accountRefundApproveByExpendature}`,
      payload
    );
  }
  fetchRefundFileUploadByClerk(orderfile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchRefundFileUploadByClerk
        .replace("{orderfile}", orderfile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  rejectedPaymentRefund(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.rejectedPaymentRefund}`,
      payload
    );
  }
  reopenPaymentRefund(payload: PaymentRefundSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.reopenPaymentRefund}`,
      payload
    );
  }
  // rejectedPaymentRefund(remark: string, status: any, applicationNo: string) {
  //   return this.httpClient.post<{ status: string; errorMessage: string }>(
  //     `${
  //       ApiUrls.rejectedPaymentRefund
  //         .replace("{remark}", remark)
  //         .replace("{applicationNo}", applicationNo) +
  //       "?status=" +
  //       status
  //     }`,
  //     null
  //   );
  // }

  savePaymentExtension(paymentExtensionSave: PaymentExtensionModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveNewPaymentExtension}`,
      paymentExtensionSave
    );
  }
  fetchPaymentDefaulterReport() {
    return this.httpClient.get<{
      lst: { [key: string]: string }[];
      title: string;
      columnNames: string[];
      columnWidths: string;
      status: string;
      errorMessage: string;
      generatedBy: string;
      generatedOn: string;
    }>(ApiUrls.fetchPaymentDefaulterReport);
  }
}
